import { Link } from 'react-router-dom';
import type { MatchResult } from '../types';
import { Avatar } from './Avatar';
import { formatCount, instrumentLabel } from '../format';
import { kmToMi } from '../units';
import { SHOWS_SHORT } from '../types';

export function MatchCard({ m }: { m: MatchResult }) {
  const u = m.user;
  return (
    <Link to={`/users/${u.id}`} className="card result" style={{ color: 'inherit' }}>
      <Avatar url={u.photoUrl} name={u.displayName} />
      <div className="body">
        <div className="row between">
          <strong>{u.displayName}{u.age !== null ? <span className="muted">, {u.age}</span> : null}</strong>
          {m.score > 0 && <span className="score">{Math.round(m.score * 100)}%</span>}
        </div>
        <div className="muted small">
          {[u.city, m.distanceKm !== null ? `${kmToMi(m.distanceKm)} mi away` : null, u.showsPlayed ? SHOWS_SHORT[u.showsPlayed] : null, u.likes > 0 ? `👍 ${formatCount(u.likes)}` : null].filter(Boolean).join(' · ')}
        </div>
        <div style={{ marginTop: 4 }}>{u.instruments.map((i) => <span className="pill" key={i}>{instrumentLabel(i)}</span>)}</div>
        {m.sharedBands.length > 0 && (
          <div className="explain">Both like <b>{m.sharedBands.map((b) => b.name).join(', ')}</b></div>
        )}
        {m.similarBands.slice(0, 2).map((s, i) => (
          <div className="explain" key={i}>You: <b>{s.yours.name}</b> · Them: <b>{s.theirs.name}</b> ({Math.round(s.score * 100)}% similar)</div>
        ))}
      </div>
    </Link>
  );
}
